import React from "react";

function Contact() {
  return (
    <div>
      <h1 className="title">Contact me </h1>
    </div>
  );
}

export default Contact;
